import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { TempServiceLineDisconnectionPage, TempServiceLineDisconnectionPageProps } from "./TempServiceLineDisconnectionPage";

export const EMPTY_PAGE_CONTENT: TempServiceLineDisconnectionPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/help-safety/near-our-network/temporary-service-line-disconnection";

export const TempServiceLineDisconnectionPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<TempServiceLineDisconnectionPageProps>(
    "electricity_disconnections___temporary_service_lin",
    EMPTY_PAGE_CONTENT,
  );
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <TempServiceLineDisconnectionPage {...routeProps} {...content} />;
};
